import React from 'react'
import * as Sentry from '@sentry/react'
import { FormattedMessage } from 'react-intl'
import ErrorBoundaryView from './errorBoundary'

// Real React error boundary (the sibling `errorBoundary.jsx` is only the
// *display* view — it has no componentDidCatch). Without one of these, any
// throw during render unmounts the whole tree → blank white screen. We wrap
// the entire app in index.js so a render crash anywhere (including one caused
// by a malformed API response) shows the friendly error page instead.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Ship the error to Sentry (no-ops when REACT_APP_SENTRY_DSN is unset)
    // along with the React component stack so the dashboard can render
    // which component crashed in addition to the JS stack frame. Same
    // capture path Sentry.ErrorBoundary uses internally — we keep the
    // explicit class component for its i18n fallback UX.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    })
    // Keep a console trail for local dev too.
    // eslint-disable-next-line no-console
    console.error('Unhandled render error caught by AppErrorBoundary:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full flex flex-col items-center justify-center">
          <ErrorBoundaryView />
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 text-[#3a6df0] underline cursor-pointer"
          >
            <FormattedMessage id="error.reload" defaultMessage="Reload" />
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default AppErrorBoundary
